// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__15iJ6","name":"ConsentHeader_name__1z5mV","birthday":"ConsentHeader_birthday__1kvMa","skeleton":"ConsentHeader_skeleton__r8Yr-"};